document.addEventListener('DOMContentLoaded', function() {
  // Function to create dots based on visible slides
  function createDots() {
    var slideshow = document.querySelector('.Product__Slideshow');
    var dotsContainer = document.querySelector('.simple-dots');
    
    if (!slideshow || !dotsContainer) return;
    
    // Clear existing dots
    dotsContainer.innerHTML = '';
    
    // Get all slides from Flickity
    var flkty = window.Flickity && slideshow ? Flickity.data(slideshow) : null;
    var allSlides = [];
    
    if (flkty && flkty.cells) {
      // Get all slides from Flickity cells
      allSlides = flkty.cells.map(cell => cell.element);
    } else {
      // Fallback to all slides in the DOM
      allSlides = Array.from(slideshow.querySelectorAll('.Carousel__Cell'));
    }
    
    // Create a dot for each slide
    allSlides.forEach(function(slide, index) {
      var dot = document.createElement('div');
      dot.className = 'dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('data-index', index);
      
      // Direct navigation using the slide's ID
      dot.onclick = function() {
        // Get the slide ID
        var slideId = slide.id;
        
        // If the slide has an ID, use it for direct navigation
        if (slideId) {
          // Create a direct link to the slide
          var slideLink = document.createElement('a');
          slideLink.href = '#' + slideId;
          slideLink.style.display = 'none';
          document.body.appendChild(slideLink);
          slideLink.click();
          document.body.removeChild(slideLink);
          
          // Update active state of dots
          dotsContainer.querySelectorAll('.dot').forEach(function(d) {
            d.classList.remove('active');
          });
          this.classList.add('active');
        } else {
          // Fallback to direct click on the slide
          slide.click();
          
          // Update active state of dots
          dotsContainer.querySelectorAll('.dot').forEach(function(d) {
            d.classList.remove('active');
          });
          this.classList.add('active');
        }
      };
      
      dotsContainer.appendChild(dot);
    });
    
    // After creating dots, check which one should be active based on scroll position
    updateActiveSlideOnScroll();
  }
  
  // Function to determine which slide is most visible in the viewport
  function updateActiveSlideOnScroll() {
    var slideshow = document.querySelector('.Product__Slideshow');
    var dotsContainer = document.querySelector('.simple-dots');
    
    if (!slideshow || !dotsContainer) return;
    
    var slides = slideshow.querySelectorAll('.Carousel__Cell');
    var dots = dotsContainer.querySelectorAll('.dot');
    
    if (!slides.length || !dots.length) return;
    
    // Get the middle of the viewport
    var viewportMiddle = window.innerHeight / 2;
    
    // Track which slide is closest to the middle of the viewport
    var closestSlide = null;
    var closestDistance = Infinity;
    
    slides.forEach(function(slide, index) {
      // Get the position of the slide relative to the viewport
      var rect = slide.getBoundingClientRect();
      var slideMiddle = rect.top + (rect.height / 2);
      
      // Calculate the distance from the middle of the viewport
      var distance = Math.abs(slideMiddle - viewportMiddle);
      
      // If this slide is closer to the middle than the current closest, update
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = index;
      }
    });
    
    // Update the active dot if we found a closest slide
    if (closestSlide !== null) {
      dots.forEach(function(dot, index) {
        if (index === closestSlide) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    // Position the dots container based on gallery position
    positionDotsContainer();
  }
  
  // Function to position the dots container
  function positionDotsContainer() {
    var dotsContainer = document.querySelector('.simple-dots');
    var productGallery = document.querySelector('.Product__Gallery');
    
    if (!dotsContainer || !productGallery) return;
    
    var galleryRect = productGallery.getBoundingClientRect();
    var dotsRect = dotsContainer.getBoundingClientRect();
    
    // Default top position
    var defaultTop = 300; // Same as in CSS
    
    // Calculate the bottom of the gallery relative to the viewport
    var galleryBottom = galleryRect.bottom;
    
    // Calculate the height of the dots container
    var dotsHeight = dotsRect.height;
    
    // Calculate the maximum top position for the dots
    var maxTop = galleryBottom - dotsHeight - 20; // 20px buffer
    
    // If the gallery bottom is approaching, adjust the top position
    if (maxTop < defaultTop) {
      dotsContainer.style.top = maxTop + 'px';
    } else {
      dotsContainer.style.top = defaultTop + 'px';
    }
  }
  
  // Initial creation of dots with a delay to ensure everything is loaded
  setTimeout(function() {
    createDots();
  }, 500);
  
  // Update dots when Flickity changes slides
  var slideshow = document.querySelector('.Product__Slideshow');
  if (slideshow && window.Flickity) {
    var flkty = Flickity.data(slideshow);
    if (flkty) {
      flkty.on('change', function(index) {
        var dots = document.querySelectorAll('.simple-dots .dot');
        dots.forEach((d, i) => {
          if (i === index) d.classList.add('active');
          else d.classList.remove('active');
        });
      });
      
      // Also listen for ready event
      flkty.on('ready', function() {
        createDots();
      });
    }
  }
  
  // Listen for variant changes
  document.addEventListener('variant:change', function(event) {
    // Wait a moment for the slides to update
    setTimeout(function() {
      createDots();
    }, 500);
  });
  
  // Also listen for any click on variant selectors
  var variantSelectors = document.querySelectorAll('.ProductForm__Option [type="radio"]');
  variantSelectors.forEach(function(selector) {
    selector.addEventListener('change', function() {
      // Wait a moment for the slides to update
      setTimeout(function() {
        createDots();
      }, 500);
    });
  });
  
  // Add scroll event listener to update active dot based on visible slide
  window.addEventListener('scroll', function() {
    // Use requestAnimationFrame to limit how often this runs
    requestAnimationFrame(function() {
      updateActiveSlideOnScroll();
      positionDotsContainer();
    });
  });
  
  // Check on page load (after images have had time to load)
  window.addEventListener('load', function() {
    updateActiveSlideOnScroll();
    positionDotsContainer();
  });
  
  // Also check when window is resized
  window.addEventListener('resize', function() {
    updateActiveSlideOnScroll();
    positionDotsContainer();
  });
}); 